import { useDeleteTimeEntryMutation } from "generated/graphql";
import getLocalString from "constants/Localization";
import useBitumioMutation from "hooks/useBitumioMutation";

export const useDeleteTimeEntry = () => {
  const [mutation, { loading, error, data }] = useDeleteTimeEntryMutation({
    update: (cache) => {
      // Also invalidate skipped views so switching tabs cannot reuse stale results.
      cache.evict({ id: "ROOT_QUERY", fieldName: "getTimeEntries" });
      cache.evict({ id: "ROOT_QUERY", fieldName: "getTimeEntriesGroupedByUser" });
    },
    awaitRefetchQueries: true,
    refetchQueries: ["customGetTimeEntries", "getTimeEntries", "getTimeEntriesGroupedByUser"],
  });

  const [deleteTimeEntry, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "deleteTimeEntry",
    },
    {
      successMessage: getLocalString("time-tracking.delete-time-entry-success"),
      failureMessage: getLocalString("time-tracking.delete-time-entry-failure"),
    }
  );

  return [deleteTimeEntry, context] as const;
};
